import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getAllCustomers } from "../../../api/pagination";
import {
  generateCustomID,
  saveData,
  uniqueID,
  uploadingImages,
} from "../../../firebase/utility";
import { orderTerms } from "../../../data";
const useNewQuotes = () => {

  const history = useHistory();
  const { id, data } = useLocation()
  const [state, setState] = useState(data ?? null)

  const { all_customers } = useSelector((state) => state.orders);
  const { user } = useSelector((state) => state.auth);
  const [status, setStatus] = useState(state?.status ?? "publish");
  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState("");
  const [new_line_items, setNewLineItems] = useState([])
  const [expiryDate, setExpiryDate] = useState(state?.expiryDate ?? '')
  const [gsaContract, setGsaContract] = useState(state?.gsaContract ?? "");
  const [terms, setTerms] = useState(state?.terms ?? "");
  const [billingData, setBillingData] = useState(
    state?.customer?.billing ?? {}
  );
  const [shippingData, setShippingData] = useState(
    state?.customer?.shipping ?? {}
  );
  const [customer, setCustomer] = useState({});
  const [searchCustomers, setSearchCustomers] = useState([])
  const [dataLoading, setDataLoading] = useState(false)
  const [pageLoader, setPageLoader] = useState(false)
  const [notes, setNotes] = useState(state?.notes ?? [])
  const [line_items, setLineItems] = useState(state?.line_items ?? []);
  const [subTotal, setSubTotal] = useState(state?.subTotal ?? 0);
  const [totalAmount, setTotalAmount] = useState(state?.totatAmount ?? 0);
  const [shippingCheckboxes, setShippingCheckboxes] = useState(
    state?.shippingCheckboxes ?? {
      sms_disabled: false,
      residiential: false,
      do_not_email: false,
      ship_partially: false,
    }
  );
  const [totalTax, setTotalTax] = useState(0)
  const [totalTaxAmount, setTotalTaxAmount] = useState(
    state?.totalTaxAmount ?? {
      tax: 0,
      shippingAmount: 0,
      insurance: 0,
      urgentShippingAmount: 0,
      discount: 0,
      refund: 0,
    }
  );
  const [itemModal, setItemModal] = useState(false);
  const toggleItemModal = () => {
    setItemModal(!itemModal);
  };
  const addQuoteNotes = () => {
    if (note !== "") {
      let obj = {
        createdAt: Date.parse(new Date()),
        createdBy: user,
        message: `${note}`
      };
      if (notes?.length > 0) {
        setNotes(
          [...notes, obj],
        );
      }
      else {
        setNotes([obj]);
      }
      setNote("")
    } else {
      toast.error("Please add note to proceed !");
    }
  };
  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setGsaContract("47QTCA25D003F");
    } else {
      setGsaContract("");
    }
  };
  const handleCustomer = (val) => {
    let source = searchCustomers?.length > 0 ? searchCustomers : all_customers
    let res =
      source?.find((i, index) => {
        return i?._id === val;
      });
    if (res) {
      setCustomer(res);
      setShippingData({
        company: res?.billing[0]?.company ?? "",
        first_name: res?.billing[0]?.first_name ?? "",
        last_name: res?.billing[0]?.last_name ?? "",
        address_1: res?.billing[0]?.address_1 ?? "",
        address_2: res?.billing[0]?.address_2 ?? "",
        city: res?.billing[0]?.city ?? "",
        state: res?.billing[0]?.state ?? "",
        phone: res?.billing[0]?.phone ?? "",
        postcode: res?.billing[0]?.postcode ?? "",
        email: res?.billing[0]?.email ?? "",
        country: res?.billing[0]?.country ?? "",
      });
      setBillingData({
        company: res?.billing[0]?.company ?? "",
        first_name: res?.billing[0]?.first_name ?? "",
        last_name: res?.billing[0]?.last_name ?? "",
        address_1: res?.billing[0]?.address_1 ?? "",
        address_2: res?.billing[0]?.address_2 ?? "",
        city: res?.billing[0]?.city ?? "",
        state: res?.billing[0]?.state ?? "",
        phone: res?.billing[0]?.phone ?? "",
        postcode: res?.billing[0]?.postcode ?? "",
        email: res?.billing[0]?.email ?? "",
        country: res?.billing[0]?.country ?? "",
      });
      setTerms(res?.billing[0]?.terms ?? "");
    }
  };
  const fetchCustomersDebounced = useCallback(
    debounce((searchText) => {
      getAllCustomers(1, searchText, 50, "", (res) => {
        if (res) {
          setSearchCustomers(res?.data?.data);
        }
        setDataLoading(false);
      });
    }, 500),
    []
  );

  const handleCustomerSearch = (searchText) => {
    setDataLoading(true);
    fetchCustomersDebounced(searchText);
  };
  // FUNCTIONS +++++++++++++++++++++++++++++++++++++++++++++++
  const calculateTotal = async () => {
    let calculate_total_amount =
      parseFloat(subTotal) +
      (parseFloat(subTotal) / 100) * parseFloat(totalTaxAmount?.tax) +
      parseFloat(totalTaxAmount?.shippingAmount) +
      parseFloat(totalTaxAmount?.insurance) +
      parseFloat(totalTaxAmount?.urgentShippingAmount) -
      parseFloat(totalTaxAmount?.discount) -
      parseFloat(totalTaxAmount?.refund);
    setTotalAmount(calculate_total_amount.toFixed(2));
  };
  const proceedClick = async (status) => {
    setLoading(true);

    const isBillingValid = billingData && billingData.first_name && billingData.address_1 && billingData.email;
    const isShippingValid = shippingData && shippingData.first_name && shippingData.address_1 && shippingData.email;

    if (!isBillingValid || !isShippingValid) {
      toast.error("Please provide both billing and shipping information Complete before proceeding.");
      setLoading(false);
      return;
    }

    if (!line_items?.length) {
      toast.error("Please add items for an order to create.");
      setLoading(false);
      return;
    }

    try {

      const arr = await uploadingImages(line_items, "quotes_images");

      const finalLineItems = line_items.map((item, index) => ({
        ...item,
        image: { src: arr[index], id: uniqueID() },
      }));


      const obj = {
        id: state?.id || (await generateCustomID("Quotes", "id")),
        subTotal,
        totalAmount,
        created_by_phone: user?.phone,
        created_by: state?.created_by || user?.username,
        updated_by: {
          username: user?.username,
          email: user?.email,
          _id: user?._id,
          updated_at: Date.now()
        },
        line_items: finalLineItems,

        customer: {
          billing: billingData,
          shipping: shippingData,
          first_name: customer?.first_name ?? "",
          last_name: customer?.last_name ?? "",
          id: customer?.id ?? "",

        },
        expiryDate: expiryDate ?? state?.expiryDate,
        _id: state?._id || uniqueID(),
        created_at: state?.created_at ?? Date.now(),
        totalTaxAmount,
        shippingCheckboxes,
        sendPdf: state?.sendPdf || false,
        status,
        notes,
        gsaContract: gsaContract ?? "",
        terms: terms ?? "",
      };


      const response = await saveData("Quotes", obj._id, obj);
      if (response) {
        toast.success(`Quote ${obj?.id} saved successfully`);
        createAdminNotification({
          title: "Quote Created",
          message: `Quote #${obj?.id} was created by ${user?.username || "Admin"}`,
          category: "quote",
          entityId: String(obj?.id),
          targetUrl: `/admin/quotes`,
          actor: user,
        }).catch(console.error);
        history.push("/admin/quotes");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while saving the quote.");
    } finally {
      setLoading(false);
    }
  };

  // USEEFFECT HOOKS ++++++++++++++++++++++++++++++++++++++++++++++++
  useEffect(() => {
    let res =
      all_customers &&
      all_customers?.find((i, index) => {
        return i?.id === state?.customer?.id;
      });
    setCustomer(res);
  }, [state]);
  useEffect(() => {
    let totalTaxRate = (parseFloat(subTotal) / 100) * parseFloat(totalTaxAmount?.tax ?? 0)
    setTotalTax(totalTaxRate)
  }, [totalTaxAmount?.tax, subTotal])
  useEffect(() => {
    let subtotal = 0;
    line_items.forEach((item) => {
      const quantity = parseInt(item.quantity);
      const price = parseFloat(item.price ?? 0);
      subtotal += quantity * price;
    });
    setSubTotal(subtotal?.toFixed(2));
    setTotalAmount(subtotal?.toFixed(2));
  }, [line_items]);
  useEffect(() => {
    calculateTotal();
  }, [totalTaxAmount, line_items, subTotal]);
  useEffect(() => {
    if (state) {
      const bill = state?.customer?.billing;
      const ship = state?.customer?.shipping;
      setShippingData({
        company: ship?.company ?? "",
        first_name: ship?.first_name ?? "",
        last_name: ship?.last_name ?? "",
        address_1: ship?.address_1 ?? "",
        address_2: ship?.address_2 ?? "",
        city: ship?.city ?? "",
        state: ship?.state ?? "",
        phone: ship?.phone ?? "",
        postcode: ship?.postcode ?? "",
        email: ship?.email ?? "",
      });
      setBillingData({
        company: bill?.company ?? "",
        first_name: bill?.first_name ?? "",
        last_name: bill?.last_name ?? "",
        address_1: bill?.address_1 ?? "",
        address_2: bill?.address_2 ?? "",
        city: bill?.city ?? "",
        state: bill?.state ?? "",
        phone: bill?.phone ?? "",
        postcode: bill?.postcode ?? "",
        email: bill?.email ?? "",
      });
      setCustomer(state?.customer);
    }
  }, [state]);
  useEffect(() => {
    if (id) {
      setPageLoader(true);
      const unsubscribe = firebase
        .firestore()
        .collection("Quotes")
        .doc(id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            const currentOrderData = doc.data();
            setState(currentOrderData);
            setLineItems(currentOrderData?.line_items ?? []);
            setGsaContract(currentOrderData?.gsaContract ?? "");
            setTerms(currentOrderData?.terms ?? "");
            setExpiryDate(currentOrderData?.expiryDate ?? null);
            setNotes(currentOrderData?.notes ?? []);
          } else {
            setState({});
            setLineItems([]);
          }
          setPageLoader(false);
        }, (error) => {
          setPageLoader(false);
        });
      return () => unsubscribe();
    }
  }, [id]);
  return {
    billingData,
    setBillingData,
    shippingData,
    setShippingData,
    all_customers,
    handleCustomer,
    customer,
    setCustomer,
    line_items,
    setLineItems,
    itemModal,
    setItemModal,
    toggleItemModal,
    totalTaxAmount,
    setTotalTaxAmount,
    subTotal,
    setSubTotal,
    totalAmount,
    setTotalAmount,
    proceedClick,
    user,
    shippingCheckboxes,
    setShippingCheckboxes,
    history,
    state,
    status,
    setStatus,
    note, setNote, addQuoteNotes, expiryDate, setExpiryDate, pageLoader,
    notes, new_line_items, setNewLineItems, totalTax, loading, handleCustomerSearch, searchCustomers, dataLoading, handleCheckboxChange, gsaContract, terms, setTerms
  };
};
export default useNewQuotes;
